module.exports = __webpack_public_path__ + "img/three-dots-vertical.8163ca41.svg";